import React, { useState, useRef, useContext } from 'react';
import { X } from 'lucide-react';
import AppContext from '../Context/AppContext';

const SideSheet = ({ children }) => {
    const { sideSheetOpen, setSideSheetOpen } = useContext(AppContext)
    const [dragY, setDragY] = useState(0)
    const startY = useRef(0)
    const dragging = useRef(false)

    const close = () => {
        setSideSheetOpen(false)
        setDragY(0)
    }

    const onTouchStart = (e) => {
        startY.current = e.touches[0].clientY
        dragging.current = true
    }
    const onTouchMove = (e) => {
        if (!dragging.current) return
        const delta = e.touches[0].clientY - startY.current
        if (delta > 0) setDragY(delta)
    }
    const onTouchEnd = () => {
        dragging.current = false
        if (dragY > 110) close()
        else setDragY(0)
    }

    return (
        <>
            <div className={`side-sheet-overlay ${sideSheetOpen ? "show" : ""}`} onClick={close}></div>

            <div
                className={`side-sheet ${sideSheetOpen ? "open" : ""}`}
                style={sideSheetOpen ? { transform: `translateY(${dragY}px)`, transition: dragging.current ? 'none' : undefined } : undefined}>
                <div
                    className='side-sheet-head'
                    onTouchStart={onTouchStart}
                    onTouchMove={onTouchMove}
                    onTouchEnd={onTouchEnd}>
                    <div className='side-sheet-grip'></div>
                    <button className='side-sheet-close' onClick={close} aria-label="Fermer"><X size={20} color='#fff' /></button>
                </div>
                <div className='side-sheet-body'>
                    {children}
                </div>
            </div>
        </>
    );
};

export default SideSheet;
